// package: user
// file: user/account_service.proto

import * as common_app from "../common/app";
import * as common_method_options from "../common/method_options";
import * as common_service_options from "../common/service_options";

import { interfaceAPI } from "../sdk/api";

export const LoginRequest = {
    encode(object) {
        const message = {};
        if (object.app != null) {
            if (object.app !== 0) {
                message.app = object.app;
            }
        }
        if (object.wechatCode != null) {
            if (object.wechatCode !== "") {
                message.wechatCode = String(object.wechatCode);
            }
        }
        if (object.channel != null) {
            if (object.channel !== "") {
                message.channel = String(object.channel);
            }
        }
        if (object.phone != null) {
            if (object.phone !== "") {
                message.phone = String(object.phone);
            }
        }
        if (object.smsCode != null) {
            if (object.smsCode !== "") {
                message.smsCode = String(object.smsCode);
            }
        }
        if (object.appleAuthorizationCode != null) {
            if (object.appleAuthorizationCode !== "") {
                message.appleAuthorizationCode = String(object.appleAuthorizationCode);
            }
        }
        if (object.appleIdentityToken != null) {
            if (object.appleIdentityToken !== "") {
                message.appleIdentityToken = String(object.appleIdentityToken);
            }
        }
        if (object.userName != null) {
            if (object.userName !== "") {
                message.userName = String(object.userName);
            }
        }
        if (object.password != null) {
            if (object.password !== "") {
                message.password = String(object.password);
            }
        }
        if (object.nvol != null) {
            if (object.nvol !== 0) {
                message.nvol = object.nvol | 0;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            app: 0,
            wechatCode: "",
            channel: "",
            phone: "",
            smsCode: "",
            appleAuthorizationCode: "",
            appleIdentityToken: "",
            userName: "",
            password: "",
            nvol: 0,
        };

        if (message.app != null) {
            object.app = message.app;
        }
        if (message.wechatCode != null) {
            object.wechatCode = message.wechatCode;
        }
        if (message.channel != null) {
            object.channel = message.channel;
        }
        if (message.phone != null) {
            object.phone = message.phone;
        }
        if (message.smsCode != null) {
            object.smsCode = message.smsCode;
        }
        if (message.appleAuthorizationCode != null) {
            object.appleAuthorizationCode = message.appleAuthorizationCode;
        }
        if (message.appleIdentityToken != null) {
            object.appleIdentityToken = message.appleIdentityToken;
        }
        if (message.userName != null) {
            object.userName = message.userName;
        }
        if (message.password != null) {
            object.password = message.password;
        }
        if (message.nvol != null) {
            object.nvol = message.nvol;
        }
        return object;
    },
};

export const LoginReply = {
    encode(object) {
        const message = {};
        if (object.token != null) {
            if (object.token !== "") {
                message.token = String(object.token);
            }
        }
        if (object.userID != null) {
            if (object.userID !== "") {
                message.userID = String(object.userID);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            token: "",
            userID: "",
        };

        if (message.token != null) {
            object.token = message.token;
        }
        if (message.userID != null) {
            object.userID = message.userID;
        }
        return object;
    },
};

export const LoginV2Request = {
    encode(object) {
        const message = {};
        if (object.app != null) {
            if (object.app !== 0) {
                message.app = object.app;
            }
        }
        if (object.wechatCode != null) {
            if (object.wechatCode !== "") {
                message.wechatCode = String(object.wechatCode);
            }
        }
        if (object.channel != null) {
            if (object.channel !== "") {
                message.channel = String(object.channel);
            }
        }
        if (object.phone != null) {
            if (object.phone !== "") {
                message.phone = String(object.phone);
            }
        }
        if (object.smsCode != null) {
            if (object.smsCode !== "") {
                message.smsCode = String(object.smsCode);
            }
        }
        if (object.appleAuthorizationCode != null) {
            if (object.appleAuthorizationCode !== "") {
                message.appleAuthorizationCode = String(object.appleAuthorizationCode);
            }
        }
        if (object.appleIdentityToken != null) {
            if (object.appleIdentityToken !== "") {
                message.appleIdentityToken = String(object.appleIdentityToken);
            }
        }
        if (object.userName != null) {
            if (object.userName !== "") {
                message.userName = String(object.userName);
            }
        }
        if (object.password != null) {
            if (object.password !== "") {
                message.password = String(object.password);
            }
        }
        if (object.wechatMiniprogramEncryptedUserInfo != null) {
            if (object.wechatMiniprogramEncryptedUserInfo !== "") {
                message.wechatMiniprogramEncryptedUserInfo = String(object.wechatMiniprogramEncryptedUserInfo);
            }
        }
        if (object.wechatMiniprogramIV != null) {
            if (object.wechatMiniprogramIV !== "") {
                message.wechatMiniprogramIV = String(object.wechatMiniprogramIV);
            }
        }
        if (object.loginSessionID != null) {
            if (object.loginSessionID !== "") {
                message.loginSessionID = String(object.loginSessionID);
            }
        }
        if (object.nvol != null) {
            if (object.nvol !== 0) {
                message.nvol = object.nvol | 0;
            }
        }
        if (object.miaoToken != null) {
            if (object.miaoToken !== "") {
                message.miaoToken = String(object.miaoToken);
            }
        }
        if (object.wechatAppID != null) {
            if (object.wechatAppID !== "") {
                message.wechatAppID = String(object.wechatAppID);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            app: 0,
            wechatCode: "",
            channel: "",
            phone: "",
            smsCode: "",
            appleAuthorizationCode: "",
            appleIdentityToken: "",
            userName: "",
            password: "",
            wechatMiniprogramEncryptedUserInfo: "",
            wechatMiniprogramIV: "",
            loginSessionID: "",
            nvol: 0,
            miaoToken: "",
            wechatAppID: "",
        };

        if (message.app != null) {
            object.app = message.app;
        }
        if (message.wechatCode != null) {
            object.wechatCode = message.wechatCode;
        }
        if (message.channel != null) {
            object.channel = message.channel;
        }
        if (message.phone != null) {
            object.phone = message.phone;
        }
        if (message.smsCode != null) {
            object.smsCode = message.smsCode;
        }
        if (message.appleAuthorizationCode != null) {
            object.appleAuthorizationCode = message.appleAuthorizationCode;
        }
        if (message.appleIdentityToken != null) {
            object.appleIdentityToken = message.appleIdentityToken;
        }
        if (message.userName != null) {
            object.userName = message.userName;
        }
        if (message.password != null) {
            object.password = message.password;
        }
        if (message.wechatMiniprogramEncryptedUserInfo != null) {
            object.wechatMiniprogramEncryptedUserInfo = message.wechatMiniprogramEncryptedUserInfo;
        }
        if (message.wechatMiniprogramIV != null) {
            object.wechatMiniprogramIV = message.wechatMiniprogramIV;
        }
        if (message.loginSessionID != null) {
            object.loginSessionID = message.loginSessionID;
        }
        if (message.nvol != null) {
            object.nvol = message.nvol;
        }
        if (message.miaoToken != null) {
            object.miaoToken = message.miaoToken;
        }
        if (message.wechatAppID != null) {
            object.wechatAppID = message.wechatAppID;
        }
        return object;
    },
};

export const LoginV2Reply = {
    encode(object) {
        const message = {};
        if (object.loginSessionID != null) {
            if (object.loginSessionID !== "") {
                message.loginSessionID = String(object.loginSessionID);
            }
        }
        if (object.token != null) {
            if (object.token !== "") {
                message.token = String(object.token);
            }
        }
        if (object.userID != null) {
            if (object.userID !== "") {
                message.userID = String(object.userID);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            loginSessionID: "",
            token: "",
            userID: "",
        };

        if (message.loginSessionID != null) {
            object.loginSessionID = message.loginSessionID;
        }
        if (message.token != null) {
            object.token = message.token;
        }
        if (message.userID != null) {
            object.userID = message.userID;
        }
        return object;
    },
};

export const PrepareCloseMyAccountRequest = {
    encode(object) {
        const message = {};
        return message;
    },

    decode(message) {
        const object = {
        };

        return object;
    },
};

export const PrepareCloseMyAccountReply = {
    encode(object) {
        const message = {};
        return message;
    },

    decode(message) {
        const object = {
        };

        return object;
    },
};

export const CloseMyAccountRequest = {
    encode(object) {
        const message = {};
        return message;
    },

    decode(message) {
        const object = {
        };

        return object;
    },
};

export const CloseMyAccountReply = {
    encode(object) {
        const message = {};
        return message;
    },

    decode(message) {
        const object = {
        };

        return object;
    },
};

export const BindWechatRequest = {
    encode(object) {
        const message = {};
        if (object.wechatCode != null) {
            if (object.wechatCode !== "") {
                message.wechatCode = String(object.wechatCode);
            }
        }
        if (object.app != null) {
            if (object.app !== 0) {
                message.app = object.app;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            wechatCode: "",
            app: 0,
        };

        if (message.wechatCode != null) {
            object.wechatCode = message.wechatCode;
        }
        if (message.app != null) {
            object.app = message.app;
        }
        return object;
    },
};

export const BindWechatReply = {
    encode(object) {
        const message = {};
        return message;
    },

    decode(message) {
        const object = {
        };

        return object;
    },
};

export function Login(request, options) {
    return interfaceAPI("/user.Account/Login", LoginRequest.encode(request), LoginReply, Object.assign({ isRequestEncrypted: 1, isAuthFree: 1, }, options));
}

export function LoginV2(request, options) {
    return interfaceAPI("/user.Account/LoginV2", LoginV2Request.encode(request), LoginV2Reply, Object.assign({ isRequestEncrypted: 1, isAuthFree: 1, }, options));
}

export function PrepareCloseMyAccount(request, options) {
    return interfaceAPI("/user.Account/PrepareCloseMyAccount", PrepareCloseMyAccountRequest.encode(request), PrepareCloseMyAccountReply, options);
}

export function CloseMyAccount(request, options) {
    return interfaceAPI("/user.Account/CloseMyAccount", CloseMyAccountRequest.encode(request), CloseMyAccountReply, options);
}

export function BindWechat(request, options) {
    return interfaceAPI("/user.Account/BindWechat", BindWechatRequest.encode(request), BindWechatReply, options);
}


